'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _WeeklyTimeWindow = require('../iterators/WeeklyTimeWindow');

var millisInMinute = 1000 * 60;

var getMillisOfMinute = function getMillisOfMinute(cal) {
    return cal.second() * 1000 + cal.millisecond();
};

var getMinuteOfWeek = function getMinuteOfWeek(cal) {
    return cal.day() * _WeeklyTimeWindow.DAY + cal.hour() * _WeeklyTimeWindow.HOUR + cal.minute();
};

var advanceCalendar = function advanceCalendar(cal, toMinuteOfWeek) {
    var millisOfMinute = getMillisOfMinute(cal);
    if (millisOfMinute > 0) {
        cal.add(millisInMinute - millisOfMinute, 'millisecond');
    }

    var currentMinuteOfWeek = getMinuteOfWeek(cal);

    var minutesToAdvance = toMinuteOfWeek - currentMinuteOfWeek;
    if (minutesToAdvance < 0) {
        minutesToAdvance += _WeeklyTimeWindow.WEEK;
    }

    // Optimization: start optimistic (assume no DST)
    cal.add(minutesToAdvance, 'minute');
    if (getMinuteOfWeek(cal) === toMinuteOfWeek) {
        return;
    }
    cal.add(-minutesToAdvance, 'minute');

    // Optimism failed, find that DST change moment
    advanceCalendarToClosestDstState(cal, !cal.isDST(), minutesToAdvance);
};

var advanceCalendarToClosestDstState = function advanceCalendarToClosestDstState(cal, targetDstState, step) {
    while (cal.isDST() !== targetDstState) {
        cal.add(step, 'minute');
    }
    if (step > 1) {
        cal.add(-step, 'minute');

        advanceCalendarToClosestDstState(cal, targetDstState, Math.floor(step / 2));
    }
};

exports.default = advanceCalendar;